import React, { Component } from "react";
import DownloadRenderer from "../../VendorOnboarding/Views/DocumentCenter/DownloadRenderer/DownloadRederer";

export default class AgGridDownloadRenderer extends Component {
  docData = {};
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.docData = this.props.data;
  }

  getDocument = (event, row) => {
    this.ref.current.href = row.data.documentPath;
    this.ref.current.download = row.data.documentName;
    this.ref.current.click();
  };

  getDocumentUrl = (notificationDocument) => {
    const documentUrl =
      notificationDocument && notificationDocument.documentUrl ? (
        <div>
          <DownloadRenderer data={notificationDocument} />
          <span style={{ overflowWrap: "break-word" }}>
            {" " +
              notificationDocument.documentName.slice(
                0,
                notificationDocument.documentName.lastIndexOf(".")
              )}
          </span>
        </div>
      ) : (
        ""
      );

    return documentUrl;
  };

  render() {
    return (
      <div>
        {this.docData && (
          <div key={this.docData.notificationId}>
            <div> {this.getDocumentUrl(this.docData)}</div>
          </div>
        )}
      </div>
    );
  }
}
